import React, { useRef, useEffect } from "react";
import classes from "./Counter.module.css";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/src/all";

//this component is needed to build the Odometer
// props: { value, }
const Counter = (props) => {
  //important to use the ScrollTrigger plugin
  gsap.registerPlugin(ScrollTrigger);
  const counter = useRef(null);
  let trigger;

  function detectBrowser() {
    if (
      (navigator.userAgent.indexOf("Opera") ||
        navigator.userAgent.indexOf("OPR")) != -1
    ) {
      return "Opera";
    } else if (navigator.userAgent.indexOf("Chrome") != -1) {
      return "Chrome";
    } else if (navigator.userAgent.indexOf("Safari") != -1) {
      return "Safari";
    } else if (navigator.userAgent.indexOf("Firefox") != -1) {
      return "Firefox";
    } else if (
      navigator.userAgent.indexOf("MSIE") != -1 ||
      !!document.documentMode == true
    ) {
      return "IE"; //crap
    } else {
      return "Unknown";
    }
  }
  //this function rolls the numbers up to the number to count to (the 104 is important)
  const count = () => {
    const browser = detectBrowser();
    if (browser === "Firefox" && props.height < 100) {
      counter.current.style.transform = `translateY(-${107.5 * props.value}%)`;
    } else if (props.height > 100) {
      counter.current.style.transform = `translateY(-${103.5 * props.value}%)`;
    } else {
      counter.current.style.transform = `translateY(-${105 * props.value}%)`;
    }
  };

  //The Reset counts back to 0
  const reset = () => {
    counter.current.style.transform = `translateY(0px)`;
  };

  // const handleWidthChange =()=>{
  //   trigger.kill()
  //   trigger = ScrollTrigger.create({
  //     trigger: counter.current,
  //     markers:true,
  //     onEnter: count,
  //     // onLeave: reset,
  //     // onEnterBack:count,
  //     onLeaveBack: reset,
  //   });
  // }

  //create the scroll animation when thE Component is rendered
  //uncomment markers:true, to debug the animation
  //markers:true, adds markers on the screen of when the animation starts and ends
  useEffect(() => {
    // window.addEventListener("resize", handleWidthChange);
    trigger = ScrollTrigger.create({
      trigger: counter.current,
      // markers:true,
      onEnter: count,
      // onLeave: reset,
      // onEnterBack:count,
      onLeaveBack: reset,
    });

    return () => {
      trigger.kill();
    };
    // eslint-disable-next-line
  }, []);

  return (
    <div className={classes.container + " " + props.className}>
      <div
        className={classes.counter}
        ref={counter}
        style={{
          height: `${props.height}px`,
          fontSize: `${props.height * 0.9}px`,
          transition: `all ${props.duration}s ease-in-out`,
        }}
      >
        {/* maps from 0 up to the number specified in props.value */}
        {[...Array(props.value + 1)].map((n, index) => (
          <div key={index} className={"number"}>
            {index}
          </div>
        ))}
      </div>
    </div>
  );
};
export default Counter;
